/**
 * created by li si yi
 * 安全检测记录弹窗
 */
import React, {Component} from 'react';
import {Empty, List, message, Modal, Steps, Typography} from "antd";
import {Scrollbars} from "react-custom-scrollbars";
import BaseComponent from "../../../base/BaseComponent";
import moment from "moment";
import $Jq from "jquery"
import {uuid} from "../../../utils";

const {Step} = Steps;
export default class RecordModal extends BaseComponent {
    static defaultProps = {
        onOk: () => {
        }
    };
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            contentVisible: false,//显示
            params: {
                start: 1,
                size: 10
            },
            dataSource: [],
            tagData: [
                {
                    title: '敏感词',
                    tagNum: 0,
                },
                {
                    title: '隐私信息',
                    tagNum: 0,
                },
                {
                    title: '敏感人物',
                    tagNum: 0,
                },
                {
                    title: '非法链接',
                    tagNum: 0,
                },
                {
                    title: '疑似外链',
                    tagNum: 0,
                },
            ],
            current: 0,
            currentClick: {},
            errorDataSource: [],
            disposeWord: [],//未处置word
        };
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    render(){
        return (
            <div>
                {/*弹窗*/}
                {this.renderModal()}
            </div>
        )
    }

    renderModal() {
        const {contentVisible, tagData, dataSource} = this.state;
        tagData.map(item => {
            item.tagNum = 0;
        });
        let sum = 0;//计算总和
        let localData = 0;//计算本地
        let cloudData = 0;//计算云端
        let externalLink = 0;//计算疑似外链
        dataSource.map((item) => {
            item.allWord.map((Item) => {
                switch (Item.category) {
                    case 'SENSITIVE':
                        tagData[0].tagNum++;
                        sum++;
                        break;
                    case 'PRIVACY_INFORMATION':
                        tagData[1].tagNum++;
                        sum++;
                        break;
                    case 'PERSON_SENSITIVE':
                        tagData[2].tagNum++;
                        sum++;
                        break;
                    case '':
                        tagData[3].tagNum++;
                        sum++;
                        break;
                    case 'OUTSIDE_CHAIN':
                        tagData[4].tagNum++;
                        sum++;
                        break;
                }
                switch (Item.wrongSource) {
                    case "LOCAL_CHECK":
                        localData++;
                        break;
                    case "CLOUD_CHECK":
                        cloudData++;
                        break;
                }
            })
        });
        tagData && tagData.map((item, index) => {
            if (item.title == '疑似外链') {
                externalLink = externalLink + item.tagNum;
            }
        });
        return (
            <>
                <Modal title={"安全检测记录"} width={800} footer={null}
                       visible={contentVisible}
                       onCancel={this.handleCancelContent}
                       bodyStyle={{height: 660}} className={'modalLeft'}>
                    <div style={{
                        width: '100%',
                        height: '80px',
                        background: 'rgba(245,108,108,0.04)',
                        padding: '16px 24px',
                        marginBottom: '24px'
                    }}>
                        <span>共检测到 敏感信息：
                            <span
                                style={{color: '#F56C6C'}}>{sum}</span> 条
                            {/*（云端检测：{cloudData ? cloudData : 0} 条、本地检测：{localData ? localData : 0} 条）   */}
                            疑似外链：
                            <span style={{color: '#0050B3'}}>{externalLink ? externalLink : 0}</span> 条</span>
                        <div style={{display: 'flex', alignItems: 'center', flexWrap: 'wrap', marginTop: '10px'}}
                             className={'tagStyle'}>其中：
                            {
                                tagData && tagData.map((item, index) => {
                                    return (
                                        <span key={index} style={{
                                            padding: '2px 8px',
                                            background: '#F56C6C',
                                            borderRadius: '2px',
                                            textAlign: 'center',
                                            fontSize: '12px',
                                            marginRight: '12px',
                                            color: '#fff'
                                        }}>{item.title} {item.tagNum}</span>
                                    )
                                })
                            }
                        </div>
                        <style>
                            {`
                                .tagStyle span:last-child{
                                     background:#F0A738 !important;
                                }
                                .modalLeft .ant-steps-item-process .ant-steps-item-icon{
                                     background:rgba(0,0,0,0);
                                     border-color:#bfbfbf;
                                }
                                .modalLeft .ant-steps-item-process .ant-steps-item-icon > .ant-steps-icon{
                                     color:#bfbfbf;
                                }
                            `}
                        </style>
                    </div>
                    {/*记录列表*/}
                    {this.renderList()}
                </Modal>
            </>
        )
    }

    //列表
    renderList = () => {
        const {current, dataSource} = this.state;
        const color1 = {
            color: 'rgba(0,0,0,0.45)',
            fontWeight: '400',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            marginRight: 10
        };
        const color2 = {color: 'rgba(0,0,0,0.85)', fontWeight: '400'};
        let windowWidth = window.innerWidth;
        return (
            <div className={'recordStyle'}>
                <Scrollbars style={{height: windowWidth < 1454 ? "calc(90vh - 390px)":"calc(90vh - 350px)"}} autoHide>
                    <Steps initial={current} direction="vertical">
                        {
                            dataSource && dataSource.map((item, index) => {
                                return (
                                    <Step
                                        key={`${new Date().getTime()}_${index}`}
                                        title={
                                            <div style={{
                                                fontSize: '14px',
                                                display: 'flex',
                                                justifyContent: 'space-between'
                                            }} key={`${new Date().getTime()}_${index}`}>
                                                <div style={{
                                                    ...color1,width: '130px',
                                                }}>
                                                    检测人：<span
                                                    style={{...color2}}
                                                    title={item.data &&item.data.createUserName ? item.data.createUserName : item.data.createStoryUserName ? item.data.createStoryUserName : ''}>{item.data &&item.data.createUserName?item.data.createUserName:item.data.createStoryUserName?item.data.createStoryUserName:''}</span>
                                                </div>
                                                <div style={{
                                                    ...color1,width: '120px',
                                                }}>
                                                    单位：<span
                                                    style={color2}
                                                    title={item.data &&item.data.deptName ? item.data.deptName : item.data.createStorydeptName ? item.data.createStorydeptName : ''}>{item.data && item.data.deptName ? item.data.deptName : item.data.createStorydeptName ? item.data.createStorydeptName : ''}</span>
                                                </div>
                                                <div style={{...color1,width:190}}>
                                                    检测时间：<span
                                                    style={color2}
                                                    title={moment(item.updateTime).format('YYYY-MM-DD HH:mm')}>{item.updateTime ? moment(item.updateTime).format('YYYY-MM-DD HH:mm') : ''}</span>
                                                </div>
                                                {/*<div style={{...color1,width: '130px'}}>*/}
                                                {/*    检测时状态：<span*/}
                                                {/*    style={color2}*/}
                                                {/*    title={item.data.storyStatusName}>{item.data && item.data.storyStatusName ? item.data.storyStatusName : ''}</span>*/}
                                                {/*</div>*/}
                                                <div
                                                    title={item.errorCount ? item.errorCount : 0}
                                                    style={{
                                                        ...color1,
                                                        verticalAlign: 'sub',width: '150px',
                                                    }}>发现异常数：<span style={color2}>{item.errorCount ? item.errorCount : 0}</span>
                                                </div>
                                            </div>
                                        }
                                        description={
                                            this.renderDescription(item, index)
                                        }
                                    />
                                )
                            })
                        }
                    </Steps>
                </Scrollbars>
                <style>
                    {`
                        .recordStyle .ant-list-bordered .ant-list-header{
                           background:#EBF1F9;
                           padding:5px 16px;
                        }
                        .recordStyle .ant-list-item{
                            padding:5px 16px;
                        }
                    `}
                </style>
            </div>
        )
    };
    //每一项内容
    renderDescription = (item, index) => {
        const color1 = {color: 'rgba(0,0,0,0.45)', fontWeight: '400'};
        const color2 = {color: 'rgba(0,0,0,0.85)', fontWeight: '400'};
        // 表头已处置，未处置
        // let notDisposed = 0;
        // let disposed = 0;
        // item.allWord && item.allWord.map((Item, Index) => {
        //     if (Item.isDispose) {
        //         disposed += 1;
        //     } else {
        //         notDisposed += 1;
        //     }
        // });
        let source;
        if(item.allWord.length < 1){
            return null
        }
        return (
            <div className={'tableStyle'}>
                <table style={{width: 688, marginTop: 10}}>
                    <thead>
                    <tr style={{background: '#EBF1F9', height: 32}}>
                        <td>
                            <div style={{
                                display: 'flex',
                                width: '100%',
                                color: 'rgba(0,0,0,0.45)',
                                margin: '0px 16px',
                                verticalAlign: 'sub'
                            }}>
                                <div style={{width: 100}}>类型</div>
                                <div style={{width: 330}}>错误</div>
                                <div style={{width: 100}}>检测源</div>
                                <div style={{width: 110}}>是否已处置</div>
                            </div>
                        </td>
                    </tr>
                    </thead>
                    <tbody>
                    {
                        item.allWord && item.allWord.map((Item, Index) => {
                            let type;
                            switch (Item.category) {
                                case 'SENSITIVE':
                                    type = '敏感词';
                                    break;
                                case 'PERSON_SENSITIVE':
                                    type = '敏感人物';
                                    break;
                                case 'OUTSIDE_CHAIN':
                                    type = '疑似外链';
                                    break;
                                case 'PRIVACY_INFORMATION':
                                    type = '隐私信息';
                                    break;
                                default:
                                    type = '';
                                    break;
                            }
                            if (Item.wrongSource && Item.wrongSource == 'LOCAL_CHECK') {
                                source = '本地检测'
                            } else if ((Item.wrongSource && Item.wrongSource == 'CLOUD_CHECK')) {
                                source = '云端检测'
                            }
                            return (
                                <tr style={{height: 32}} key={index + "_" + Index}>
                                    <td>
                                        <div style={{
                                            display: 'flex',
                                            width: '100%',
                                            margin: '9px 16px',
                                            color: 'rgba(0,0,0,0.65)'
                                        }}>
                                            <div style={{width: 90}}>{type}</div>
                                            <div title={Item.category==='SENSITIVE'?`“${Item.word}”建议修改为“${Item.correctWord}”`:`“${Item.word}”建议删除`} style={{
                                                width: 340,
                                                overflow: 'hidden',
                                                whiteSpace: 'nowrap',
                                                textOverflow: 'ellipsis',
                                                verticalAlign: 'sub',
                                            }}>“<span style={{
                                                color: '#F56C6C',
                                                cursor: 'pointer'
                                            }}>{Item.word}</span>”，建议{Item.category==='SENSITIVE'?`修改为“${Item.correctWord}”`:`删除`}
                                            </div>
                                            <div
                                                style={{width: 100}}>{source ? source : ""}</div>
                                            <div style={{width: 110}}>{Item.isDispose ? "是" : "否"}</div>
                                        </div>
                                    </td>
                                </tr>
                            )
                        })
                    }</tbody>
                </table>
                <style>
                    {`
                    .tableStyle tbody tr{
                      height:32px;
                      border:1px solid rgba(0,80,179,0.08);
                    }
                    `}
                </style>
            </div>
        )
    };
    // 获取数据
    getItemDataSource = (key) => {
        let params = {
            key: key,
        };
        this.request({
            url: "/cm-sites-sys/contentCheck/getAllCheckLogByKey",
            body: params,
            callBack: (res) => {
                let dataSource = [];
                // let wrong=0;//
                // let political=0;//敏感词
                // let outside=0;//外链
                // let person=0;
                // let privacy=0;//敏感人物
                if (res) {
                    dataSource = res;
                    //是否已处置
                    // res.map(item=>{
                    //     wrong=item.wrongWordTypeCount.WRONG_CHARACTER+wrong;
                    // })
                } else {
                    message.error("数据获取失败！");
                }
                this.setState({dataSource});
                dataSource.map(item => {
                    if (dataSource.length > 0 && item.allWord.length > 0) {
                        this.isDispose();
                    }
                });
                // 倒叙
                let num = $Jq('.ant-steps .ant-steps-item .ant-steps-item-container .ant-steps-item-icon .ant-steps-icon').length;
                $Jq('.ant-steps .ant-steps-item .ant-steps-item-container .ant-steps-item-icon .ant-steps-icon', function () {
                    $Jq('.ant-steps .ant-steps-item .ant-steps-item-container .ant-steps-item-icon .ant-steps-icon').each(function (index, val) {
                        $Jq(this).text(num--);
                    });
                })
            },
            errorCallBack: (e) => {
                console.log(e)
            }
        });
    };
    //是否已处置
    isDispose = () => {
        let {dataSource} = this.state;
        let endData = [];//最后一项数据
        if (dataSource[0].allWord && dataSource[0].allWord.length) {
            endData = dataSource[0].allWord;
        }

        //最后一项word
        let endDataWord = [];
        endData.map(item => {
            if (item.word) {
                endDataWord.push(item.word)
            }
        });

        // 每一项和最后一项对比
        dataSource && dataSource.map((item) => {
            item.allWord.map(Item => {
                if (endDataWord.includes(Item.word)) {
                    Item.isDispose = false
                } else {
                    Item.isDispose = true
                }
            });
        });
        this.setState({dataSource})
    };
    // 显示
    showModal = (record) => {
        this.setState({contentVisible: true, currentClick: record});
        this.getItemDataSource(record.key);
    };
    // 取消
    handleCancelContent = () => {
        if(typeof this.props.onCloseCall==='function'){
            this.props.onCloseCall()
        }
        this.setState({contentVisible: false});
    };
    // 分页改变
    pageChange = (start, size) => {
        // 获取当前tab参数
        this.setState({
            start,
            size
        });
        this.getDataSource();
    };
}